<template>
  <div class="periods">
    <!-- 待支付侧边栏 -->
    <div v-if="ISnoData">
      <div class="leftTip">
        <div class="text" v-if="settledAccount">待支付金额 (元)</div>
        <div class="num" v-if="settledAccount">
          <p style="font-size: 35px" v-html="havePaidInfo.unRefundAmountNew1">
            {{ havePaidInfo.unRefundAmountNew1 }}
          </p>
          <!-- <span>{{ havePaidInfo.unRefundAmountNew1 }}</span>
          <span v-if="havePaidInfo.unRefundAmountNew2"
            >.{{ havePaidInfo.unRefundAmountNew2 }}</span
          >-->
        </div>
        <div v-if="!settledAccount" class="settled-account">账单已结清</div>
        <div class="line"></div>
        <div class="text">应收：</div>
        <div class="text2 text-hidden">{{ havePaidInfo.benqiYS }}元</div>
        <div class="text">账期：</div>
        <div class="text2 text-hidden">
          {{ havePaidInfo.billStar }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
            havePaidInfo.billEnd
          }}
        </div>
        <div class="text">账单数：</div>
        <div class="text2 text-hidden">{{ havePaidInfo.total }}</div>
        <div v-if="!NewDialogBox3">
        <el-popover
          placement="bottom-start"
          width="500"
          trigger="click"
          v-model="confirmPayment"
        >
          <div class="confirm-payment-box">
            <h4 style="color: #000">支付账单<span style="color:red;margin-left: 30px;font-size: 12px;">温馨提示：请勿转账给个人！</span></h4>
            <!-- <div class="gray-word" style="margin: 10px 0">
              支付后，即默认您已确认账单无异常
            </div> -->
            <div class="df" style="text-align: right; margin-top: 15px">
              <div class="money" style="line-height: 32px">
                支付金额：<span>￥</span>
              </div>
              <div style="width: 100px; margin: 0px 15px 0 5px">
                <el-input
                  size="small"
                  placeholder="0.00"
                  v-model="money"
                ></el-input>
              </div>
              <el-button
                size="small"
                slot="reference"
                @click="confirmPayment = false"
                >暂不支付
              </el-button>
              <el-button
                size="small"
                slot="reference"
                @click="showBankAccount('')"
                >电汇转账
              </el-button>
              <el-button
                type="primary"
                size="small"
                slot="reference"
                @click="allPayment"
                >确认支付
              </el-button>
            </div>
          </div>
          <div
            class="pay text-no"
            @click="payAll(havePaidInfo.unRefundAmountNew)"
            slot="reference"
          >
            支付全部账单
          </div>
        </el-popover>
       </div>
        <div
        v-if="NewDialogBox3"
          class="pay text-no"
          @click="payAll(havePaidInfo.unRefundAmountNew)"
          slot="reference"
        >
          支付全部账单
        </div>
        <h5 style="margin-top:8px;color:red; font-size:12px;">温馨提示：请勿转账给个人</h5>
      </div>
    </div>
    <!-- 中间内容 -->
    <div class="content" v-if="ISnoData">
      <!-- 待支付账单 -->
      <div class="box-list">
        <!-- 搜索框 -->
        <div class="search">
          <el-input
            placeholder="输入对账单号"
            v-model="statementBillNo"
            class="input-with-select"
            size="small"
            clearable
            @clear="clearSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleIconClick"
            ></el-button>
          </el-input>
        </div>
        <!-- 批量操作按钮 -->
        <!-- havePaidInfo.earlyTotal == 0 -->
        <div class="bulk-operation-box df" v-if="NotPayingBills.length > 0">
          <div class="headline">
            <signboard signboardName="待支付账单"></signboard>
          </div>
          <div v-if="!bulkOperation" class="bulk-operation">
            <el-button type="text" @click="bulkOperations">批量操作 </el-button>
          </div>
          <div v-else class="bulk-operation df">
            <el-button type="text" @click="bulkOperations"
              >取消批量操作
            </el-button>
            <div class="cut-off-rule" v-if="!showBatchConfirmationBill"></div>
            <el-button
              type="text"
              @click="BatchConfirmationStatement()"
              v-if="!showBatchConfirmationBill"
              >批量确认账单
            </el-button>
            <div class="cut-off-rule"></div>
            <div class="fr df" v-if="!showBatchConfirmationBill">
              <div class="money">支付金额：<span>￥</span></div>
              <div class="df">
                <div class="money-input" v-if="!isDisabled">
                  <el-input
                    size="small"
                    placeholder="0.00"
                    v-model="money"
                    disabled
                  ></el-input>
                </div>
                <div class="money-input" v-else>
                  <el-input
                    size="small"
                    placeholder="0.00"
                    v-model="money"
                  ></el-input>
                </div>
                <div>
                  <el-button type="primary" size="small" @click="selectPayment"
                    >支付已选金额
                  </el-button>
                </div>
              </div>
            </div>
            <div class="fr df" v-if="showBatchConfirmationBill">
              <div class="money money-input">
                已选账单数：{{ BillSelectedQuantity }}
              </div>
              <div class="df">
                <div>
                  <el-button
                    type="primary"
                    size="small"
                    @click="BatchConfirmationBill"
                    >确认已选账单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 待支付列表 -->
        <div v-if="!showBatchConfirmationBill" class="df unpaid-list">
          <div
            class="item"
            v-for="(item, key) in NotPayingBills"
            :key="item.value"
            :class="item.check ? 'bgc' : ''"
          >
            <div
              :class="[
                item.status == 'un_confirm' && bulkOperation
                  ? 'title-img'
                  : 'title',
                'df',
              ]"
            >
              <div class="df w50">
                <div
                  class="checkbox"
                  v-if="bulkOperation"
                  @change.stop="checked(item, key)"
                >
                  <el-checkbox
                    :value="item.check"
                    v-if="item.status == 'confirm'"
                  ></el-checkbox>
                </div>
                <div
                  class="gray-word text-hidden pointer"
                  :title="item.statBillNo"
                  @click="out(item)"
                >
                  {{ item.statBillNo }}
                </div>
              </div>
              <div class="text-align-right w50 text-hidden">
                <span class="gray-word">待支付：</span>
                <span class="bgc-blue">{{ item.unRefundAmount }}元</span>
              </div>
            </div>
            <div class="list gray-word" @click="out(item)">
              <div
                class="row df pointer text-hidden"
                :title="item.actionOrgName"
              >
                <div>营业部：</div>
                <div>{{ item.actionOrgName }}</div>
              </div>
              <div class="row df text-hidden">
                <div>账期：</div>
                <div>
                  {{
                    item.billStar
                      ? $moment(item.billStar).format("YYYY-MM-DD") +
                        "&nbsp;&nbsp;至&nbsp;&nbsp;"
                      : ""
                  }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                  <!-- {{
                    $moment(item.billStar).format("YYYY-MM-DD")
                  }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
                    $moment(item.billEnd).format("YYYY-MM-DD")
                  }} -->
                </div>
              </div>
            </div>
            <div class="df btn">
              <div class="df" v-if="!bulkOperation">
                <!-- 支付账单按钮 -->
                <el-popover
                  placement="bottom-start"
                  width="500"
                  trigger="click"
                  v-model="item.confirmPayment"
                >
                  <div>
                    <h4 style="color: #000">确认账单，并支付<span style="color:red;margin-left: 30px;font-size: 12px;">温馨提示：请勿转账给个人！</span></h4>
                    <div class="gray-word" style="margin: 10px 0">
                      支付后，即默认您已确认账单无异常
                    </div>
                    <div class="df">
                      <div class="money" style="line-height: 32px">
                        支付金额：<span>￥</span>
                      </div>
                      <div style="width: 100px; margin: 0px 15px 0 5px">
                        <el-input
                          size="small"
                          placeholder="0.00"
                          v-model="money"
                        ></el-input>
                      </div>
                      <el-button
                        type="primary"
                        size="small"
                        slot="reference"
                        @click="singlePayment(item)"
                        >确认支付
                      </el-button>
                      <el-button
                        size="small"
                        slot="reference"
                        @click="showBankAccount(item.statBillNo)"
                        >电汇转账
                      </el-button>
                      <el-button
                        size="small"
                        slot="reference"
                        @click="item.confirmPayment = false"
                        >暂不支付
                      </el-button>
                    </div>
                  </div>
                  <el-button
                    type="primary"
                    size="small"
                    slot="reference"
                    @click="pay(item.unRefundAmount)"
                    >支付账单
                  </el-button>
                </el-popover>
                <!-- 确认账单按钮 -->
                <el-popover
                  v-if="item.status == 'un_confirm'"
                  placement="bottom"
                  width="300"
                  trigger="click"
                  v-model="item.ConfirmTheBill"
                >
                  <div>
                    <h4 style="color: #000">确认账单提醒</h4>
                    <div class="gray-word" style="margin: 10px 0">
                      您是否要确认对账账单？确认后不可更改。
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="small"
                        slot="reference"
                        @click="item.ConfirmTheBill = false"
                        >暂不确认
                      </el-button>
                      <el-button
                        type="primary"
                        size="small"
                        slot="reference"
                        @click="confirmPay(item)"
                        >确认对账单
                      </el-button>
                    </div>
                  </div>
                  <el-button
                    class="padding-left"
                    type="text"
                    slot="reference"
                    size="small"
                    >确认账单
                  </el-button>
                </el-popover>
                <el-button
                  class="padding-left"
                  size="small"
                  type="text"
                  v-else
                  disabled
                  >确认对账单
                </el-button>
                <div class="cut-off-rule"></div>
                <!-- 获取账单 -->
                <el-popover
                  placement="bottom"
                  trigger="click"
                  v-model="item.ToGetTheBill"
                >
                  <div
                    class="pointer"
                    style="text-align: center; color: #000; line-height: 28px"
                  >
                    <div
                      style="margin-bottom: 10px; color: #00000085"
                      @click="ToGetTheBill(item, key, '下载账单')"
                    >
                      下载账单
                    </div>
                      <div
                      style="margin-bottom: 10px; color: #00000085"
                      @click="ToGetTheBill(item, key, '异步下载账单')"
                    >
                      异步下载账单
                    </div>
                    <!-- <div @click="item.ToGetTheBill2 = false">打印账单</div> -->
                    <div
                      style="color: #00000085"
                      @click="ToGetTheBill(item, key, '发送邮箱')"
                    >
                      发送邮箱
                    </div>
                  </div>
                  <el-button type="text" slot="reference" size="small"
                    >获取账单<i class="el-icon-arrow-down"></i
                  ></el-button>
                </el-popover>
              </div>
              <div v-else>
                <div v-if="item.status == 'un_confirm'">
                  该账单未确认，不能支付
                </div>
                <div v-if="item.status == 'confirm'">
                  <el-button
                    v-if="!item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >选择账单
                  </el-button>
                  <el-button
                    v-if="item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >取消账单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 批量确认列表 -->
        <div v-else class="df unpaid-list">
          <div
            class="item"
            v-for="(item, key) in NotPayingBills"
            :key="item.value"
            :class="item.check ? 'bgc' : ''"
          >
            <div
              :class="[
                item.status == 'confirm' && bulkOperation
                  ? 'title-img'
                  : 'title',
                'df',
              ]"
            >
              <div class="df w50">
                <div
                  class="checkbox"
                  v-if="bulkOperation"
                  @change.stop="checked(item, key)"
                >
                  <el-checkbox
                    :value="item.check"
                    v-if="item.status == 'un_confirm'"
                  ></el-checkbox>
                </div>
                <div
                  class="gray-word text-hidden pointer"
                  :title="item.statBillNo"
                  @click="out(item)"
                >
                  {{ item.statBillNo }}
                </div>
              </div>
              <div class="text-align-right w50 text-hidden">
                <span class="gray-word">待支付：</span>
                <span class="bgc-blue">{{ item.unRefundAmount }}元</span>
              </div>
            </div>
            <div class="list gray-word" @click="out(item)">
              <div
                class="row df pointer text-hidden"
                title="上海嘉定区浦江镇营业部"
              >
                <div>营业部：</div>
                <div>{{ item.actionOrgName }}</div>
              </div>
              <div class="row df text-hidden">
                <div>账期：</div>
                <div>
                  {{
                    item.billStar
                      ? $moment(item.billStar).format("YYYY-MM-DD") +
                        "&nbsp;&nbsp;至&nbsp;&nbsp;"
                      : ""
                  }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
            <div class="df btn">
              <div>
                <div v-if="item.status == 'confirm'">
                  该账单已确认，不能重复确认
                </div>
                <div v-if="item.status == 'un_confirm'">
                  <el-button
                    v-if="!item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >选择账单
                  </el-button>
                  <el-button
                    v-if="item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >取消账单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 待支付分页  v-if="NotPayingBills.length > 5" -->
        <div class="bottom">
          <el-pagination
            v-if="earlyTotal1 > 6"
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currpage1"
            :page-sizes="[6, 12, 24]"
            :page-size="pagesize1"
            layout="total,prev, pager, next, sizes,jumper"
            :total="havePaidInfo.earlyTotal"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 已支付账单 -->
      <div class="box-list" v-if="PaidBill.length > 0">
        <div class="headline">
          <signboard signboardName="已支付账单"></signboard>
        </div>
        <!-- 已支付列表 -->
        <div class="df unpaid-list">
          <div class="item" v-for="(item, key) in PaidBill" :key="item.value">
            <div class="title title-img w50 df">
              <div
                class="df"
                :title="item.statBillNo"
                @click.stop="copy(item.statBillNo)"
              >
                <div class="gray-word text-hidden pointer">
                  {{ item.statBillNo }}
                </div>
              </div>
              <div class="df">
                <div class="gray-word">总金额：</div>
                <div class="gray-word">{{ item.totalAmount }}元</div>
              </div>
            </div>
            <div class="list gray-word" @click="out(item)">
              <div class="row df pointer" title="上海嘉定区浦江镇营业部">
                <div>营业部：</div>
                <div>{{ item.actionOrgName }}</div>
              </div>
              <div class="row df">
                <div>账期：</div>
                <div>
                  {{
                    item.billStar
                      ? $moment(item.billStar).format("YYYY-MM-DD") +
                        "&nbsp;&nbsp;至&nbsp;&nbsp;"
                      : ""
                  }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
            <div class="btn df">
              <!-- 获取账单 -->
              <el-popover
                placement="bottom"
                trigger="click"
                v-model="item.ToGetTheBill"
              >
                <div
                  class="pointer"
                  style="text-align: center; color: #000; line-height: 28px"
                >
                  <div @click="ToGetTheBill(item, key, '下载账单')">
                    下载账单
                  </div>
                  <div
                   style="text-align: center; color: #000; line-height: 28px"
                      @click="ToGetTheBill(item, key, '异步下载账单')"
                    >
                      异步下载账单
                    </div>
                  <!-- <div @click="ToGetTheBill = false">打印账单</div> -->
                  <!-- <div @click="open(item)">发送邮箱</div> -->
                  <div @click="ToGetTheBill(item, key, '发送邮箱')">
                    发送邮箱
                  </div>
                </div>
                <el-button type="text" slot="reference" size="small"
                  >获取账单<i class="el-icon-arrow-down"></i
                ></el-button>
              </el-popover>
            </div>
            <div class="closed-account-img">
              <img
                class="Open-according-to"
                src="../../../assets/picture/closed-account.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 已支付分页 v-if="havePaidInfo.length > 12" -->
        <div class="bottom">
          <el-pagination
            v-if="earlyTotal2 > 6"
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currpage2"
            :page-sizes="[6, 12, 24]"
            :page-size="pagesize2"
            layout="total,prev, pager, next, sizes,jumper"
            :total="earlyTotal2"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 搜索沒有数据显示 -->
      <div class="no-data" v-if="noData">
        <noContent explain="没有搜到相关对账单"></noContent>
      </div>
    </div>
    <!-- 无数据展示 -->
    <div class="is-no-data" v-if="!ISnoData">
      <noContent img="2" :explain="explain1"></noContent>
    </div>
    <!-- 下载账单弹框 -->
    <el-dialog
      class="fl"
      title="请选择下载账单格式"
      :visible.sync="NewDialogBox1"
      width="34%"
      top="236px"
    >
      <div class="strong-frame">
        <div class="row">
          <div
            :class="DownloadTheformat == 'excel' ? 'divpitch-on' : ''"
            @click="DownloadTheformat = 'excel'"
          >
            <img class="excel" src="../../../assets/picture/excel.png" alt="" />
          </div>
          <div
            :class="DownloadTheformat == 'pdf' ? 'divpitch-on' : ''"
            @click="DownloadTheformat = 'pdf'"
          >
            <img class="pdf" src="../../../assets/picture/pdf.png" alt="" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox1 = false" size="small">取 消</el-button>
        <el-button
          @click="download"
          type="primary"
          size="small"
          :loading="downloadLoading"
          >下载</el-button
        >
      </span>
    </el-dialog>
    <!-- 账单发送邮箱 -->
    <el-dialog
      class="fl"
      title="发送邮箱"
      :visible.sync="NewDialogBox2"
      width="34%"
      top="236px"
    >
      <div
        v-for="(emailItem, index) in emailList"
        :key="index"
        style="margin-bottom: 8px"
      >
        <div class="strong-frame top df">
          <span style="width: 80px; line-height: 32px">邮箱{{ index + 1 }}：</span>
          <el-input
            v-model="emailItem.value"
            :placeholder="`请输入邮箱${index + 1}`"
            size="small"
          ></el-input>
          <i
            v-if="index > 0"
            class="el-icon-delete"
            style="margin-left: 8px; line-height: 32px; cursor: pointer; color: #f56c6c;"
            @click="emailList.splice(index, 1)"
          ></i>
        </div>
        <div
          v-if="emailItem.error"
          style="color: #f56c6c; font-size: 12px; padding-left: 80px"
        >邮箱格式不正确</div>
      </div>
      <div style="margin-top: 8px">
        <el-button
          v-if="emailList.length < 3"
          type="text"
          icon="el-icon-plus"
          size="small"
          @click="addEmail"
        >新增邮箱</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox2 = false" size="small">取 消</el-button>
        <el-button @click="SendEmail" type="primary" size="small"
          >发 送</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量确认账单弹框 -->
    <!-- <el-dialog
      class="fl"
      title="温馨提示"
      :visible.sync="NewDialogBox3"
      width="34%"
      top="236px"
    >
      <div class="strong-frame top df">{{ batchStatBillNos }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox3 = false" size="small"
          >取消支付</el-button
        >
        <el-button @click="BillConfirmation()" type="primary" size="small"
          >确认账单</el-button
        >
      </span>
    </el-dialog> -->
    <!-- 批量确认账单弹框 -->
    <el-dialog
      class="fl"
      title="温馨提示"
      :visible.sync="NewDialogBox3"
      width="34%"
      top="236px"
    >
      <div class="strong-frame top df">{{ ConfirmBillPrompt }}</div>
      <div
        v-if="!FullQuantityConfirmation"
        slot="footer"
        style="text-align: center"
      >
        <el-button @click="NewDialogBox3 = false" size="small">{{
          whetherTick ? "取消确认" : "去勾选"
        }}</el-button>
        <el-button
          v-if="whetherTick"
          @click="BillConfirmation"
          style="margin-left: 100px"
          type="primary"
          size="small"
          >确认账单</el-button
        >
      </div>
      <div v-else slot="footer" style="text-align: center">
        <el-button @click="NewDialogBox3 = false" size="small"
          >取消确认</el-button
        >
        <el-button
          @click="FullQuantityConfirmationBtn"
          style="margin-left: 100px"
          type="primary"
          size="small"
          >确认账单</el-button
        >
      </div>
    </el-dialog>

    <!-- 银行账号复制 -->
    <el-dialog
      title="电汇账号信息"
      :visible.sync="isShowAccountDialog"
      width="450px">
      <div class="e_account">
        <div><label for="">开户名：</label>{{formAccount.compBankAccountName}}</div>
        <div><label for="">开户行：</label>{{formAccount.compBankName}}</div>
        <div><label for="">开户账号：</label>{{formAccount.compBank}}</div>
        <h5 style="margin-top:8px;color:red; font-size:12px;">温馨提示：请勿转账给个人！</h5>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowAccountDialog = false" size="small">关 闭</el-button>
        <el-button type="primary" @click="copyAccountInfo" size="small">一键复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import API from "../../../api/bill";
import noContent from "@/components/noContent";
import axios from "axios";
const api = new API();
export default {
  components: { noContent, signboard },
  data() {
    return {
      FullQuantityConfirmation: false,
      whetherTick: false,
      ConfirmBillPrompt: "",
      BillSelectedQuantity: 0,
      showBatchConfirmationBill: false,
      batchStatBillNos: "",
      downloadLoading: false,
      emailList: [{ value: "", error: false }],
      mailbox: "",
      gitBill: "",
      DownloadTheformat: "excel",
      NewDialogBox3: false,
      NewDialogBox1: false,
      NewDialogBox2: false,
      settledAccount: true,
      explain1: "账单预计将于10号前生成！",
      ISnoData: true,
      BillGeneration: false, //账单生成中显示
      noData: false, //搜索无数据显示
      confirmPayment: false, //侧边栏支付账单按钮
      currpage1: 1, //待支付默认开始页面
      pagesize1: 6, //待支付每页的数据条数
      earlyTotal1: 0, //待支付总条数
      timeId: null,
      currpage2: 1, //默认开始页面
      pagesize2: 6, //每页的数据条数
      earlyTotal2: 0, //已支付总条数
      // ToGetTheBill: false,
      check: false,
      bulkOperation: false,
      statementBillNo: "",
      money: "",
      state: "",
      // explain: "没有搜到相关对账单",
      timeQuantum: "",
      isDisabled: false,
      checkArray: [],
      NotPayingBills: [],
      PaidBill: [],
      unpaidInfo: [],
      havePaidInfo: [],
      barTotalMoney: null,
      isShowAccountDialog:false,
      formAccount:{}
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 全量确认账单
    FullQuantityConfirmationBtn() {
      (this.NewDialogBox3 = false), this.confirmAllBill();
    },
    async confirmAllBill() {
      let res = await api.confirmAllBill();
      console.log(res);
      this.$message({
        message: "确认成功",
        type: "success",
      });
      setInterval(() => {
        location.reload();
      }, 2000);
    },
    // 批量确认账单
    BatchConfirmationBill() {
      this.NewDialogBox3 = true;
      this.batchStatBillNos = [];
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          this.batchStatBillNos.push(item.statBillNo);
        }
      });
      console.log(this.batchStatBillNos, "this.batchStatBillNos");
      if (this.batchStatBillNos.length == 0) {
        this.ConfirmBillPrompt = "请勾选对账单";
        this.whetherTick = false;
      } else {
        this.whetherTick = true;
        this.ConfirmBillPrompt = "未确认账单：" + this.batchStatBillNos;
      }
      //   this.confirmPay()
    },
    // 批量确认账单按钮
    BatchConfirmationStatement() {
      this.BillSelectedQuantity = 0;
      this.showBatchConfirmationBill = true;
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          item.check = false;
        }
      });
    },
    // 批量确认账单 确认按钮
    BillConfirmation() {
      this.NewDialogBox3 = false;
      api.confirmBillList(this.batchStatBillNos).then((res) => {
        this.$message({
          message: "确认成功",
          type: "success",
        });
        setInterval(() => {
          location.reload();
        }, 2000);

        console.log(res);
      });
    },
    // 全部账单支付弹窗
    payAll(money) {
      this.money = money;
      this.checkConfirm();
    },
    async checkConfirm() {
      let res = await api.checkConfirm();
      if (res.success == false) {
        this.whetherTick = true;
        this.ConfirmBillPrompt = res.msg;
        this.FullQuantityConfirmation = true;
        this.NewDialogBox3 = true;
      }
    },
    // 获取邮箱
    async getCustomerEmail() {
      let res = await api.getCustomerEmail();
      if (res) {
        this.emailList = [{ value: res[0] || "", error: false }];
        this.mailbox = res[0] || "";
      }
    },
    // 新增邮箱输入行
    addEmail() {
      if (this.emailList.length < 3) {
        this.emailList.push({ value: "", error: false });
      }
    },
    // 发送邮箱
    SendEmail() {
      var reg =
        /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
      let hasError = false;
      const validEmails = [];
      this.emailList.forEach((emailItem) => {
        const email = (emailItem.value || "").trim();
        if (email) {
          if (reg.test(email)) {
            emailItem.error = false;
            validEmails.push(email);
          } else {
            emailItem.error = true;
            hasError = true;
          }
        } else {
          emailItem.error = false;
        }
      });
      if (hasError || validEmails.length === 0) {
        return;
      }
      this.mailbox = validEmails.join(",");
      this.$emit("acquireEmail", this.mailbox);
      this.sendEmailExcel();
    },
    async sendEmailExcel() {
      let parme = {
        statBillNo: this.gitBill,
        email: this.mailbox,
      };
      let res = await api.sendEmailExcel(parme);
      if (res) {
        if (res == "发送成功！") {
          this.NewDialogBox2 = false;
          console.log(res);
          this.$message({
            message: res,
            type: "success",
          });
        }
      } else {
        console.log(res);
      }
    },
    // 下载
    download() {
      console.log("下载");
      this.downloadLoading = true;
      api
        .startDownload({
          statBillNo: this.gitBill,
          downLoadType: this.DownloadTheformat,
        })
        .then((resp) => {
          let downloadKey = resp;
          console.info(downloadKey);
          window.sessionStorage.setItem("downloadKey", downloadKey);
          this.timeId = window.setTimeout(() => {
            //应用setInterval来刷新getList()
            this.tryDownLoad();
          }, 1000);
        });
    },
    tryDownLoad() {
      let downloadKey = window.sessionStorage.getItem("downloadKey");
      let preParam = {
        statBillNo: this.gitBill,
        downLoadType: this.DownloadTheformat,
        downloadStatus: "query",
        downloadKey: downloadKey,
      };
      axios
        .post("statements/downloadFile", preParam)
        .then((res) => {
          if ("success" == res.data) {
            this.downloadFinal();
          } else {
            console.info("downloading");
          }
          if ("downloading" == res.data) {
            window.setTimeout(() => {
              this.tryDownLoad();
            }, 2000);
          }
        })
        .catch(function (error) {
          console.info(error);
        });
    },
    async downloadFinal() {
      // let list_name = "账单";
      let downloadKey = window.sessionStorage.getItem("downloadKey");
      let param = {
        statBillNo: this.gitBill,
        downLoadType: this.DownloadTheformat,
        downloadStatus: "download",
        downloadKey: downloadKey,
      };
      let res = await api.downloadFile2(param);
      this.downloadLoading = false;
      this.NewDialogBox1 = false;
      this.$message({
        message: "下载成功",
        type: "success",
      });
      // debugger
      let link = document.createElement("a");
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = decodeURI(
        escape(
          res.headers["content-disposition"].replace("attachment;filename=", "")
        )
      ); //  下载的时候的文件名
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
      window.clearInterval(this.timeId);
      this.timeId = null;
    },
    // 获取账单
    ToGetTheBill(item, key, distinction) {
      // this.NotPayingBills[key].ToGetTheBill = false
      this.gitBill = item.statBillNo;
      console.log(this.gitBill);
      if (distinction == "下载账单") {
        console.log("下载账单");
        this.NewDialogBox1 = true;
      } else if(distinction == "异步下载账单"){
        console.log(window.localStorage.getItem("customerCode"))
        let formData = {
          "customerCode":window.localStorage.getItem("customerCode"),
          "statementNo":item.statBillNo 
        }
        api.launchPCStatBillFile(formData).then((res) => {
          if(res.success && res.data){
            item.ToGetTheBill = false;
              this.$message({
              message:res.data,
              type: "success",
            });
          }
        });
      } else {
        this.EmailError = false;
        this.NewDialogBox2 = true;
        this.getCustomerEmail();
        console.log("发送邮箱");
      }
      console.log(item, key);
    },
    // 批量操作
    bulkOperations() {
      this.showBatchConfirmationBill = false;
      this.money = 0;
      this.bulkOperation = !this.bulkOperation;
      if (!this.bulkOperation) {
        this.NotPayingBills.forEach((item) => {
          item.check = false;
        });
      }
    },
    pay(money) {
      // item.payMoney = item;
      this.money = money;
    },
    clearSearch() {
      this.NotPayingBillsRequest(); // 待支付请求
      this.PaidBillRequest(); // 已支付请求
    },
    out(item) {
      //去详情页
      console.log(item);
      window.sessionStorage.setItem("detailBill", JSON.stringify(item));
      window.localStorage.setItem("detailBill", JSON.stringify(item));
      this.$router.push({ path: "/bill/detailBill" });
    },
    // 待支付账单 分页 : 选择展示条数
    handleSizeChange1(val) {
      this.pagesize1 = val;
      this.currpage1 = 1; // 切换 没有多少条的时候 重置为第1页开始
      this.NotPayingBillsRequest();
      this.BillSelectedQuantity = 0;
    },
    // 待支付账单 :分页 : 换页
    handleCurrentChange1(val) {
      this.currpage1 = val;
      this.NotPayingBillsRequest();
      this.BillSelectedQuantity = 0;
    },
    //已支付账单 分页 : 选择展示条数
    handleSizeChange2(val) {
      this.pagesize2 = val;
      this.currpage2 = 1;
      this.PaidBillRequest();
    },
    // 已支付账单 分页 : 换页
    handleCurrentChange2(val) {
      this.currpage2 = val;
      this.PaidBillRequest();
    },
    // 加减金额计算
    AmountOfCalculation() {
      this.money = 0;
      this.checkArray = [];
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          this.checkArray.push(item);
          this.money += item.unRefundAmount;
        }
      });
      // this.money = this.money.toFixed(2)
    },
    //未支付勾选框
    checked(item, key) {
      if (this.showBatchConfirmationBill == true) {
        this.NotPayingBills[key].check = !item.check;
        let aa = this.NotPayingBills;
        this.NotPayingBills = [];
        this.NotPayingBills = aa;
        this.BillSelectedQuantity = 0;
        this.NotPayingBills.forEach((item) => {
          if (item.check) {
            this.BillSelectedQuantity++;
          }
        });
        console.log("勾选", item, this.NotPayingBills[key].check);
        return;
      }
      if (item.unRefundAmount < 0) {
        this.$message({
          showClose: true,
          message: "账单应收未负值，无需支付，请联系对账会计处理！",
          type: "error",
          offset: 300,
        });
      }
      this.NotPayingBills[key].check = !item.check;
      this.isDisabled = true;
      if (item.check) {
        this.AmountOfCalculation();
        this.ToInvoice = true;
        this.mayMake = true;
      } else {
        this.AmountOfCalculation();
        if (this.checkArray.length == false) {
          this.isDisabled = false;
          return;
        }
      }
    },
    async confirmPay(item) {
      console.log(1, item);
      item.ConfirmTheBill = false;
      // 请求确认对账单接口
      api.confirmBillList([item.statBillNo]).then((res) => {
        item.status = "confirm";
        console.log(2, item);
        console.log(res);
      });
    },
    // 单个支付，手动确认
    singlePayment(item) {
      console.log("单个账单支付", item);
      if (this.money > item.unRefundAmount) {
        this.money = item.unRefundAmount;
        return this.$message({
          showClose: true,
          message: "支付金额不能大于账单金额",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.money = item.unRefundAmount;
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }
      item.confirmPayment = false;
      // 调用支付
      this.payment([item.statBillNo], this.money);
    },
    // 全量支付
    allPayment() {
      console.log("支付全部账单", this.havePaidInfo);
      if (this.money > this.havePaidInfo.unRefundAmountNew) {
        this.money = this.havePaidInfo.unRefundAmountNew;
        return this.$message({
          showClose: true,
          message: "支付金额不能大于账单金额",
          type: "error",
          offset: 300,
        });
      }
      if (this.money <= 0) {
        this.money = this.havePaidInfo.unRefundAmountNew;
        return this.$message({
          showClose: true,
          message: "输入金额不能小于或等于0",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.money = this.havePaidInfo.unRefundAmountNew;
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }
      api.createPmcTotalPaymentOrder("" + this.money).then((res) => {
        if(res.success){
          window.open(res.cashierUrl);
        }
        this.$message({
          message:res,
          type: "error",
          offset: 300,
        });
      });

      // api.createTotalPayOrder("" + this.money).then((res) => {
      //   console.log(res);
      //   window.open(res);
      // });
      this.confirmPayment = false;
    },
    // 选中支付
    selectPayment() {
      if (this.checkArray.length == false) {
        this.$message({
          showClose: true,
          message: "请先勾选账单再进行操作",
          type: "error",
          offset: 300,
        });
        return;
      }
      if (this.money <= 0) {
        this.AmountOfCalculation();
        // this.money = this.money.toFixed(2)
        return this.$message({
          showClose: true,
          message: "输入金额不能小于或等于0",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.AmountOfCalculation();
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }

      console.log("支付账单");
      let statBillNos = [];
      var totalMoney = 0;
      this.checkArray.forEach((item) => {
        // 判断是否选中了未确认的账单
        if (item.status == "un_confirm") {
          this.$message({
            showClose: true,
            message: "请先确认账单：" + item.statBillNo + " !",
            type: "error",
            offset: 300,
          });
          return;
        }
        // 累加金额
        totalMoney = totalMoney + item.unRefundAmount;
        statBillNos.push(item.statBillNo);
      });
      if (totalMoney < this.money) {
        this.AmountOfCalculation();
        this.$message({
          showClose: true,
          message: "手填金额大于账单最大总和！",
          type: "error",
          offset: 300,
        });
        return;
      }

      if (this.money <= 0) {
        this.$message({
          showClose: true,
          message: "支付金额应大于 0 元！",
          type: "error",
          offset: 300,
        });
        return;
      }
      console.log(statBillNos, this.money);
      // 调用支付
      this.payment(statBillNos, this.money);
    },
    // 批量支付，自动确认
    payment(statBillNos, money) {
      //支付
      api.createPmcPaymentOrder("" + money, statBillNos).then((payRes) => {
        if(payRes.success){
          window.open(payRes.cashierUrl);
          return;
        }
        this.$message({
          message:payRes,
          type: "error",
          offset: 300,
        });
      });

      // api.createPayOrder("" + money, statBillNos).then((res) => {
      //   console.log("支付url: ", res);
      //   window.open(res);
      // });
    },
    handleIconClick() {
      //搜索
      if (this.statementBillNo.replace(/\s*/g, "") == "") {
        this.NotPayingBillsRequest(); // 待支付请求
        this.PaidBillRequest(); // 已支付请求
        return;
      }
      this.billNumberRequest();
    },
    copy(data) {
      // 点击复制运单号
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },

    // 侧边栏数据处理
    havePaidInfos() {
      this.ISnoData = true;
      this.havePaidInfo.billEnd = this.$moment(
        this.havePaidInfo.billEnd
      ).format("YYYY-MM-DD");
      this.havePaidInfo.billStar = this.$moment(
        this.havePaidInfo.billStar
      ).format("YYYY-MM-DD");
      // this.havePaidInfo.unRefundAmountNew1 = ("" + this.havePaidInfo.unRefundAmount).split(
      //   "."
      // )[0];
      //  this.havePaidInfo.unRefundAmountNew1 =this.havePaidInfo.unRefundAmount.toString();
      this.havePaidInfo.unRefundAmountNew1 = this.separateNum(
        this.havePaidInfo.unRefundAmount.toString()
      );
      // this.havePaidInfo.unRefundAmountNew2 = ("" + this.havePaidInfo.unRefundAmount).split(
      //   "."
      // )[1];
    },
    // 用逗号分隔开
    separateNum(value) {
      if (!value) return "0.00";
      var intPart = value.split('.')[0]
      // var intPart = Number(value).toFixed(0); //获取整数部分
// console.log('0000', value.split('.')[0]);
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
      var floatPart = ".00"; //预定义小数部分
      var value2Array = value.split(".");
      //=2表示数据有小数位
      var totalMoney;
      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分
        if (floatPart.length == 1) {
          //补0,
          totalMoney = intPartFormat + "." + floatPart + "0";
          totalMoney = totalMoney.split(".");
          return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
        } else {
          totalMoney = intPartFormat + "." + floatPart;
          totalMoney = totalMoney.split(".");
          return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
        }
      } else {
        totalMoney = intPartFormat + floatPart;
        totalMoney = totalMoney.split(".");
        console.info("total:" + totalMoney);
        //this.unRefundAmountNew1=`${totalMoney[0]}.<span style="font-size:12px;">${totalMoney[1]}</span>`;
        return `${totalMoney[0]}.<span style="font-size:20px;">${totalMoney[1]}</span>`;
      }
    },
    // 待支付列表请求
    async NotPayingBillsRequest() {
      let parme = {
        currentPage: this.currpage1,
        pageSize: this.pagesize1,
        isPaid: "N",
      };
      let res = await api.PaidBillRequest(parme);
      if (res) {
        this.noData = false;
        this.ISnoData = true;
        this.earlyTotal1 = res.earlyTotal;
        this.havePaidInfo = JSON.parse(JSON.stringify(res));
        this.havePaidInfo.unRefundAmountNew = res.unRefundAmount;
        this.havePaidInfos();
        this.NotPayingBills = res.early;
        this.NotPayingBills.forEach((item) => {
          item.check = false;
        });
      } else {
        this.settledAccount = false;
      }
    },
    // 已支付请求
    async PaidBillRequest() {
      let parme = {
        currentPage: this.currpage2,
        pageSize: this.pagesize2,
        isPaid: "Y",
      };
      let res = await api.PaidBillRequest(parme);
      if (res) {
        this.noData = false;
        this.ISnoData = true;
        this.earlyTotal2 = res.earlyTotal;
        this.PaidBill = res.early;
        if (this.havePaidInfo.length == 0) {
          this.havePaidInfo = JSON.parse(JSON.stringify(res));
          this.havePaidInfo.unRefundAmountNew = res.unRefundAmount;
          this.havePaidInfos();
        }
      }
    },
    // 搜索框请求
    async billNumberRequest() {
      let parme = {
        statementBillNo: this.statementBillNo,
        currentPage: 1,
        pageSize: 5,
        isPaid: "",
      };
      let res = await api.PaidBillRequest(parme);
      this.currpage1 = 1; //待支付默认开始页面
      this.pagesize1 = 5; //待支付每页的数据条数
      this.currpage2 = 1; //默认开始页面
      this.pagesize2 = 5; //每页的数据条数
      this.earlyTotal2 = 0; //已支付总条数
      this.earlyTotal1 = 0;
      this.havePaidInfo.earlyTotal = 0;
      console.log(res);
      if (res) {
        console.log("有数据");
        this.noData = false;
        if (res.early[0].settledStatus == "un_completion") {
          this.NotPayingBills = res.early;
          this.PaidBill = [];
          this.earlyTotal2 = res.earlyTotal;
        } else {
          this.PaidBill = res.early;
          this.NotPayingBills = [];
          this.havePaidInfo.earlyTotal = res.earlyTotal;
        }
      } else {
        this.noData = true;
        this.NotPayingBills = [];
        this.PaidBill = [];
        return console.log("无数据");
      }
    },

    //显示账号信息
    async showBankAccount(statBillNo){
      let formData = {
        statementBillNo:statBillNo,
        customerCode: window.localStorage.getItem("customerCode"),
      }
      let res = await api.queryBankInfoByStatNoOrCustomerCode(formData)
      if(res instanceof Object){
        this.confirmPayment = false;
        this.isShowAccountDialog = true
        this.formAccount = res;
      }
    },

    //复制银行账号
    copyAccountInfo(){
     // 点击复制运单号
      let { compBankAccountName, compBankName, compBank } = this.formAccount;
      let str = `${compBankAccountName}-${compBankName}-${compBank}`;
      let oInput = document.createElement("input");
      oInput.value = str;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "账号复制成功,请到银联app转账！请勿转账给个人",
        type: "success",
      });
      oInput.remove();
      this.isShowAccountDialog = false;
    }
  },
  mounted() {
    if (this.havePaidInfo.length == 0) {
      this.ISnoData = false;
      if (this.$moment().locale("zh-cn").format("DD") > 10) {
        this.explain1 = "暂未查询到本期账单";
      }
    }
  },
  filters: {},
  /*  filters: {
    //var velue=this.unRefundAmountNew1;
    money(value) {

      if (!value) return "0.00";
      var intPart = Number(value).toFixed(0); //获取整数部分
      var intPartFormat = intPart
              .toString()
              .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); //将整数部分逢三一断
      var floatPart = ".00"; //预定义小数部分
      var value2Array = value.split(".");
      //=2表示数据有小数位
      if (value2Array.length == 2) {
        floatPart = value2Array[1].toString(); //拿到小数部分
        if (floatPart.length == 1) {
          //补0,
          return intPartFormat + "." + floatPart + "0";
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        return intPartFormat + floatPart;
      }
    }
  },*/
  created() {
    this.NotPayingBillsRequest(); // 待支付请求
    this.PaidBillRequest(); // 已支付请求
  },
};
</script>
<style lang='less' scoped>
.periods {
  display: flex;
  height: 100%;
  flex: 1;
  overflow: auto;
  .Email-error {
    font-size: 13px;
    color: #f56c6c;
    text-align: left;
    padding-left: 70px;
    margin-top: 5px;
  }
  .top {
    margin-top: 5px;
  }
  .strong-frame {
    .row {
      display: flex;
      div {
        width: 68px;
        height: 68px;
        background: #f2f2f2;
        margin-right: 32px;
      }
      .divpitch-on {
        background: #d4ebff;
        border-radius: 3px;
        border: 1px solid #008cff;
      }
      .excel {
        margin-top: 16px;
        width: 40px;
        height: 36px;
      }
      .pdf {
        margin-top: 13px;
        width: 35px;
        height: 42px;
      }
    }
  }
  .is-no-data {
    width: 100%;
    margin-top: 150px;
  }
  .headline {
    margin-left: -12px;
  }

  .leftTip {
    width: 245px;
    margin-right: 6px;
    padding: 24px;
    background-image: url("../../../assets/bg.png");
    background-repeat: no-repeat;
    background-size: 102%;
    text-align: left;
    .settled-account {
      height: 42px;
      font-size: 30px;
      font-weight: 500;
      color: #008cff;
      line-height: 42px;
    }
    .text {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.4);
      line-height: 20px;
    }

    .num {
      color: #008cff;
      font-family: DIN-Medium, DIN;

      span:nth-child(1) {
        font-size: 35px;
        font-weight: 500;
        line-height: 40px;
      }

      span:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
      }
    }

    .line {
      margin: 16px 0;
      border-top: 1px solid #00000014;
    }

    .text2 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin: 4px 0 16px;
      cursor: pointer;
    }

    .downloadBill {
      cursor: pointer;
      margin: 20px 0;
      display: flex;
      width: 100%;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #008cff;

      .confirm {
        flex: 1;
      }

      .gap {
        height: 22px;
        border-left: 1px solid #00000014;
      }

      .download {
        flex: 1;
      }
    }

    .pay {
      text-align: center;
      height: 32px;
      width: 100%;
      background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
      box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
      border-radius: 4px;
      line-height: 32px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .content {
    font-size: 14px;
    padding-left: 24px;
    flex: 1;

    .text-align-right {
      text-align: right;
    }

    .bgc {
      border: 1px solid #008cff;
    }

    .search {
      width: 328px;
      text-align: left;
    }

    .bulk-operation-box {
      justify-content: space-between;
      line-height: 60px;

      /deep/ .el-input--small .el-input__inner {
        text-align: right;
      }

      .bulk-operation {
        .money-input {
          width: 108px;
          margin: 0 24px 0 6px;
          // margin: -10px 24px 0 6px;
        }

        .money {
          color: rgba(0, 0, 0, 0.6);
        }

        .cut-off-rule {
          margin: 17px 20px;
          background-color: rgba(0, 0, 0, 0.08);
          width: 1px;
          line-height: 60px;
          height: 26px;
        }
      }
    }

    .unpaid-list {
      overflow: auto;
      display: flex;
      flex-wrap: wrap;
    }

    .box-list {
      flex-wrap: wrap;

      .el-icon-arrow-down {
        margin-left: 5px;
      }
      .item:hover {
        box-shadow: 1px 9px 20px 1px #ececec;
        border: 1px #ececec solid;
      }
      .item {
        border: 1px solid #ececec;
        width: 360px;
        margin-right: 32px;
        margin-bottom: 24px;
        background: #ffffff;
        border-radius: 4px;
        padding-bottom: 16px;
        position: relative;

        .title {
          line-height: 52px;
          padding: 0 16px;
          width: 100%;
          justify-content: space-between;
          background-image: url("../../../assets/picture/background-blue.png");
          background-repeat: no-repeat;
          background-size: 102%;
          border-radius: 4px 4px 0 0;

          .checkbox {
            margin-right: 6px;
          }

          .w50 {
            width: 50%;
          }
        }

        .title-img {
          line-height: 52px;
          padding: 0 16px;
          width: 100%;
          justify-content: space-between;
          background-image: url("../../../assets/picture/background-gray.png");
          background-repeat: no-repeat;
          background-size: 102%;
          border-radius: 4px 4px 0 0;

          .checkbox {
            margin-right: 6px;
          }

          .w50 {
            width: 50%;
          }
        }

        .list {
          padding: 12px 16px;
          padding-bottom: 32px;
          .row {
            line-height: 24px;
          }
        }

        .btn {
          padding-left: 16px;
          height: 32px;

          .cut-off-rule {
            margin: 6px 16px;
            width: 1px;
            background-color: rgba(0, 0, 0, 0.08);
          }

          .padding-left {
            padding-left: 18px;
          }
        }
      }

      /*.item:nth-child(3n) {
        margin-right: 0;
      }*/

      .closed-account-img {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .bottom {
      text-align: left;
    }

    .no-data {
      margin-top: 100px;
    }
  }
}
.el-message {
  top: 48% !important;
}

.text {
  font-size: 14px;
  color: #323233;
  line-height: 20px;
}

.periods .leftTip {
  border: solid 1px #ececec;
}
.e_account{
  div{
    text-align: left;
    margin-bottom: 10px;
    label{
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-left:30px;
    }
  }
}
// .periods .el-input {
//   top: 10px;
// }
/*.item:hover{     box-shadow: 1px 9px 20px 1px #ECECEC; }*/
</style>